import React from 'react'
import { number, string } from 'prop-types'
import { Card, Image } from 'semantic-ui-react'
import { parkingIcons } from '../../../../utils/ParkingIcons'
import { connect } from 'react-redux'

const Message = ({ signs, subCategory }) =>
  `Showing ${signs} ${subCategory || ''} signs`

const MetaInfo = ({ subCategory }) => {
  if (subCategory) {
    return 'Click All Signs to clear the Filter'
  } else {
    return 'Filter Signs based on sub Category using menu above'
  }
}

const ChartHeaderText = ({ subCategory, signs, theme }) => (
  <Card.Group>
    <Card fluid color="red">
      <Card.Content>
        {subCategory && (
          <Image floated="right" size="mini" src={parkingIcons(subCategory)} />
        )}
        <Card.Header>
          <Message signs={signs} subCategory={subCategory} />
        </Card.Header>
        <Card.Meta>
          <MetaInfo subCategory={subCategory} />
        </Card.Meta>
      </Card.Content>
    </Card>
  </Card.Group>
)

ChartHeaderText.propTypes = {
  signs: number.isRequired,
  theme: string.isRequired,
}

const mapStateToProps = ({ spi, signsState }) => ({
  theme: spi.theme,
  subCategory: spi.subCategory,
  signs: signsState.cache.signs.length,
})

export default connect(mapStateToProps)(ChartHeaderText)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/SubTypeChart/HeaderText.jsx